
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class ValidatorsHelper {
  // Numeric validation (≥ 0)
  static numeric(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value === null || value === '') return null;
    
    // Check if it's a number and ≥ 0
    if (isNaN(value) || parseFloat(value) < 0) {
      return { numeric: true };
    }
    return null;
  }

  // Positive numbers only (> 0)
  static positive(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value === null || value === '') return null;
    
    if (isNaN(value) || parseFloat(value) <= 0) {
      return { positive: true };
    }
    return null;
  }

  // Integer validation (whole numbers)
  static integer(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value === null || value === '') return null;
    
    if (!Number.isInteger(parseFloat(value))) {
      return { integer: true };
    }
    return null;
  }

}
